import './ReqRes.sass'
import {useState} from 'react'
import Markdown from 'comps/Markdown.js'
import {Row, Col} from 'react-bootstrap'
import {ReactComponent as IconInfo} from 'img/icon/info.svg'
import {ReactComponent as IconSend} from 'img/icon/arrow_send.svg'
import {ReactComponent as IconReceive} from 'img/icon/arrow_receive.svg'
import ReactJson from 'react-json-view'
import HeaderParameterTable from './HeaderParameterTable.js'
import cleanJsonString from 'tool/cleanJsonString.js'
import ResponseExample from './ResponseExample.js'
import {MethodBadge} from './Badges.js'
import IconExpandContract from './IconExpandContract.js'

const descriptionStyle = {border: 'solid thin var(--gray-dark)', padding: 20, background: 'var(--light)'} 
export {descriptionStyle}

const ReqRes = (props) => {
    const [showContent, _setshowContent] = useState(false)
    const toggleFolderContent = () => _setshowContent(!showContent)

    const description = props.request?.description
    const content = (
        <Row className="reqres-container no-gutters d-flex align-items-center mt-3 pb-1">
            <Row onClick={toggleFolderContent} className="no-gutters cursor-pointer w-100">
                <Col xs="11" className="reqres-title-container"><h4 className="reqres-title" style={{display: 'inline-block'}}>RequestType: {props.name}</h4></Col>
                <Col xs="1" className="d-flex align-items-end justify-content-end">
                  <IconExpandContract value={!showContent} />
                </Col>
                <Col xs="12"><MethodBadge method={props?.request?.method} /><span className="url pl-3">/{props.request?.url?.path.join("/")}</span></Col>
            </Row>
            <Row className={`content-expandable ${showContent?'show':'hide'} pb-3 w-100`}>
                <Col xs={12}>
                    <MarkdownDescription string={description} />
                </Col>

                <Col xs="12">
                    <RequestSection request={props.request}/>
                </Col>
                <Col xs="12">
                    <ResponseSection response={props.response}/>
                </Col>
            </Row>
        </Row>

    )

    return isReqRes(props) ? content : null
}

export default ReqRes

const MarkdownDescription = (props) => {
    if(!props.string) return null
    
    return (
        <div className="mt-3 mb-3">
            <Col xs="auto"className="p-0 d-flex align-items-center">
                <IconInfo width={25} height={25} style={{marginRight: 5, marginBottom: 5}}/>
                <h5>Description</h5>
            </Col>
            <Markdown small style={descriptionStyle}>{props.string}</Markdown>
        </div>
    )
}

const RequestSection = (props) => {
    const header = props.request?.header?.length > 0 ? props.request?.header : []
    let bodyString = props.request?.body?.raw ? props.request?.body?.raw : null
    bodyString = cleanJsonString(bodyString)
    
    return(
        <Row className="mt-3 mb-3">
            <Col xs="auto" className="d-flex align-items-center">
                <IconSend width={27} height={27} style={{marginRight: 5, marginBottom: 5}}/>
                <h4>Request</h4>
            </Col>
            <Col xs={12} className="mt-2">
                <Col xs={12} >
                    <h5>Header</h5>
                    <Col xs={12} style={descriptionStyle}>
                        <HeaderParameterTable header={header}/>
                    </Col>
                </Col>
            </Col>
            <Col xs={12} className="mt-3">
                <Col xs={12} >
                    <h5>Body</h5>
                    <Col xs={12} style={descriptionStyle}>
                        {bodyString ? <ReactJson src={bodyString} displayDataTypes={false} name={false}/> : null}
                    </Col>
                </Col>
            </Col>
        </Row>
    )
}

const ResponseSection = (props) => {
    if(Array.isArray(props.response) === false || props.response.length === 0) return null

    return(
        <Row className="mt-3 mb-3">
            <Col xs="auto" className="d-flex align-items-center">
                <IconReceive width={27} height={27} style={{marginRight: 5, marginBottom: 5}}/>
                <h4>Response</h4>
            </Col>
            <Col xs={12} className="mt-2">
                {props.response.map((o,i)=> <ResponseExample key={i} title={`Example ${i+1}`} {...o} hideResponseHeader/> )}
            </Col>
        </Row>
    )
}


const isReqRes = (props) => {
    return props.request instanceof Object
}
export {isReqRes}
